export default __webpack_public_path__ + "static/media/VKOW_11_mos_MPOL.a03df98f.wav";